import React from 'react';
import PropTypes from 'prop-types';
import AnchorLink from 'react-anchor-link-smooth-scroll';


import './DesktopNavigation.module.css';

import FacebookIcon from 'Images/icon_facebook.png';
import InstagramIcon from 'Images/icon_instagram.png';

DesktopNavigation.PropTypes = {
  data: PropTypes.object,
};

function DesktopNavigation({ data }) {
  return (
    <nav styleName="DesktopNavigation">
      <ul>
        {
          data.navigation.map((item) => (
            <li key={item.navigation.target}>
              <a href={`/#${item.navigation.target}`}>
                { item.navigation.name }
              </a>
            </li>
          ))
        }
        <li styleName="socialMediaIcons">
          <a href={data.instagram}>
            <img src={InstagramIcon} alt="Instagram Icon" />
          </a>
          <a href={data.facebook}>
            <img src={FacebookIcon} alt="Facebook Icon" />
          </a>
        </li>
      </ul>
    </nav>
  );
}

export default DesktopNavigation;


// WEBPACK FOOTER //
// ./src/components/Header/DesktopNavigation.js